<template>
  <div class="accordion">
    <div class="accordion--title" v-on:click="toggle()">
      <h6 v-html="title"/>
      <p class="accordion-conditions" :style="{ 'background-color': conditionsColor || '#00aaa7' }" v-if="conditionsLength">
        {{ conditionsLength }}
      </p>
      <i
        :class="{ 'accordion-arrow-bottom': opened, 'accordion-arrow-right': !opened}"
        class="material-icons accordion-arrow"
      >chevron_right</i>
    </div>
    <transition appear>
      <div class="accordion-content" :class="{ 'flex-accordion': beFlex }" v-show="opened">
        <slot>
        </slot>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'Accordion',
  props: {
    title: {
      type: String
    },
    showOnStartup: {
      type: Boolean,
      default: true
    },
    flex: {
      type: Boolean,
      default: false
    },
    conditionsLength: {
      type: Number,
      default: null
    },
    conditionsColor: {
      type: String
    }
  },
  data () {
    return {
      opened: false,
      beFlex: false
    }
  },
  mounted () {
    if (this.showOnStartup) {
      this.opened = true
    }
    if (this.showOnStartup && this.flex) {
      this.beFlex = true
    }
  },
  methods: {
    toggle () {
      this.opened = !this.opened
      if (this.flex && this.opened) {
        this.beFlex = true
      }
      if (!this.opened) {
        this.beFlex = false
      }
      this.$emit('changeExpand', this.opened)
    }
  }
}
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@100;200;300;400;500;600;700;800;900&display=swap');
.v-enter,
.v-leave-to {
  opacity: 0
}
.v-leave,
.v-enter-to {
  opacity: 1
}
.v-enter-active,
.v-leave-active {
  transition: opacity 500ms
}

.accordion {
  width: auto;
  height: auto;
  min-height: 25px;
  position: relative;
  border-radius: 10px;
  padding: 24px 5px 0px 5px;
  border: 1px solid rgb(185, 185, 185);
  & .accordion--title {
    margin: 0;
    width: 100%;
    display: flex;
    cursor: pointer;
    position: absolute;
    align-items: center;
    transform: translateY(-50%);
    -ms-transform: translateY(-50%);
    & h6 {
      font-size: 14px;
      font-weight: 500;
      color: #080808;
      padding-left: 5px;
      font-family: 'Inter', sans-serif;
    }
    & .accordion-arrow {
      right: 10px;
      float: right;
      position: fixed;
      color: rgb(107, 106, 106) !important;
    }
    & .accordion-conditions {
      margin-left: 10px;
      color: #fff;
      border-radius: 80px;
      width: 30px;
      height: 20px;
      text-align: center;
      font-family: 'Inter', sans-serif;
      font-size: 13px;
      padding-top: 2px;
    }
  }
}
/* arrow common style */
.accordion-arrow-right {
  transition: all 0.3s ease-in-out;
}
.accordion-arrow-bottom {
  transition: all 0.3s ease-in-out;
  transform: rotate(90deg);
}
.accordion-content {
  padding: 7px 5px;
}
.flex-accordion {
  display: flex !important;
}
@keyframes fadeInDown {
  from {
    opacity:0;
    -webkit-transform: translatey(-10px);
    -moz-transform: translatey(-10px);
    -o-transform: translatey(-10px);
    transform: translatey(-10px);
  }
  to {
    opacity:1;
    -webkit-transform: translatey(0);
    -moz-transform: translatey(0);
    -o-transform: translatey(0);
    transform: translatey(0);
  }
}
</style>
